"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('distribute-vertically', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("mask", {
    fill: props.innerStrokeColor
  }, _react.default.createElement("use", {
    xlinkHref: "#path-1"
  })), _react.default.createElement("g", {
    mask: "url(#mask-2)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(24.000000, 24.000000) rotate(90.000000) translate(-24.000000, -24.000000) translate(7.500000, 6.000000)"
  }, _react.default.createElement("rect", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    transform: "translate(16.500000, 18.000000) rotate(90.000000) translate(-16.500000, -18.000000) ",
    x: "2.5",
    y: "12",
    width: "28",
    height: "12"
  }), _react.default.createElement("path", {
    d: "M32.5,0 L32.5,36",
    fill: "none",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M0.5,3.55271368e-15 L0.5,36",
    fill: "none",
    strokeLinecap: props.strokeLinecap
  }))))));
});

exports.default = _default;